// Weld-mode glyphs, exported from the weld-mode designs. Both are normalized
// into the shared 28x28 icon box: scaled so the glyph spans y 2-26 and
// centered horizontally, which matches the optical size of the rest of the
// library. The source artwork carries its own color (muted for the torch,
// orange for the arc); here both inherit `currentColor` so the consumer sets
// the tone.

/** Weld torch with no arc — the dry-run mode indicator. */
export const weldTorch = (
  <g transform="translate(0.4635 -0.5513) scale(1.44293)">
    <path
      d="M11.4453 2.2858V7.42838L10.9277 7.94595H10.1602V10.9733C10.1602 11.5181 10.3765 12.0412 10.7617 12.4264L13.4893 15.154V15.8854L12.9453 16.4274L14.1865 17.6696L13.8213 18.0358L13.4551 18.401L12.2129 17.1598L11.6709 17.7028H10.9395L8.21191 14.9762C7.15047 13.9148 6.55371 12.4744 6.55371 10.9733V7.94595H5.78516L5.26758 7.42838V2.2858L5.78516 1.76822H10.9277L11.4453 2.2858ZM7.58887 10.9733C7.58887 12.2001 8.07592 13.3773 8.94336 14.2448L11.3047 16.6051L12.3916 15.5192L10.0303 13.1579C9.45107 12.5786 9.125 11.7924 9.125 10.9733V7.94595H7.58887V10.9733ZM6.30273 6.91177H7.07031L7.07129 6.9108H9.64258L9.64355 6.91177H10.4111V2.80338H6.30273V6.91177Z"
      fill="currentColor"
    />
  </g>
);

/** Weld torch striking an arc — the live-weld mode indicator. */
export const weldArc = (
  <g transform="translate(2 -0.82353) scale(1.41176)">
    <path
      d="M9.50977 8.06152L10.3467 7.46484L14.5107 4.49023L11.5361 8.6543L10.9385 9.49023L17 10.5L10.9395 11.5098L14.5107 16.5107L9.50977 12.9385L8.5 19L7.48926 12.9395L2.49023 16.5107L6.06055 11.5098L0 10.5L6.06152 9.48926L2.49023 4.48926L7.48926 8.06055L8.5 2L9.50977 8.06152Z"
      fill="currentColor"
    />
  </g>
);
